module.exports = __webpack_public_path__ + "img/graduation.6aa6e735.svg";